import React from 'react';
import {Alert, Form, Icon, Input, Button, Row, Col, Upload } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { importConsentRequest } from "../../../api/requests";

import classes from './ConsentUploadForm.css';
import { logout } from "../../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

class ConsentUploadForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const formData = new FormData();
          if (values.document_file && values.document_file.file) { formData.append('file', values.document_file.file); }

          // formData.append('name', values.name);
          // formData.append('comments', values.comments);

          await importConsentRequest(formData);

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', this.props.i18n.t('Error')) } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.i18n.t('NamespaceConsentUploadForm:Upload Consent')}
          </h4>

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t('Select .zip')}</b>
                <Form.Item>
                  {getFieldDecorator('document_file', {
                    initialValue: get(this.props, 'document_file', ''),
                  })(
                    <Upload accept='.zip' action='' beforeUpload={() => false} multiple={false} fileList={get(this.props.form.getFieldValue('document_file'), 'fileList', []).slice(-1)}>
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue('document_file') && this.props.url ? 'Change file' : 'Upload consent' }
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>

              {!this.props.form.getFieldValue('document_file') && this.props.url && (
                <div><a href={this.props.url} target='_blank'>{this.props.url}</a><br/><br/></div>
              )}
            </Col>
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            <Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'consentUploadForm' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ConsentUploadForm)));



// WEBPACK FOOTER //
// ./src/containers/SettingsConsent/ConsentUploadForm/ConsentUploadForm.js